import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import LazyLoad from "react-lazy-load";

import Layout from "./../components/Layout";
import styled from "styled-components";
import config from "../shards-pro/config.json";

import "bootstrap/dist/css/bootstrap-grid.min.css";

import { MdLock } from "react-icons/md";

function setupOrderOrIndex(c, idx) {
  c.order = c.order || idx;
  return c;
}

function sortItemsByOrder(a, b) {
  const a_ord = parseInt(a.order);
  const b_ord = parseInt(b.order);

  if (a_ord === b_ord) return 0;
  if (a_ord < b_ord) {
    return -1;
  } else {
    return 1;
  }
}

config.categories = config.categories.map((c, idx) => {
  c = setupOrderOrIndex(c, idx);

  if (!c.items) {
    return c;
  } else {
    c.items = c.items.map(function(i, idx) {
      i.order = i.src.match(/\d+/)[0] || idx;
      return i;
    });
    c.items = c.items.sort(sortItemsByOrder);
    return c;
  }
});

config.categories = config.categories.sort(sortItemsByOrder);

const SimpleLocked = () => (
  <SimpleLockWrapper>
    <MdLock />
  </SimpleLockWrapper>
);

const SimpleLockWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  padding: 5px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  border-radius: 50%;
  right: 10px;
  top: 10px;

  > * {
    color: #fff;
    margin: auto;
    font-size: 15px;
  }
`;

const Block = ({ item, index }) => {
  const preview_sm = item.preview.split('.')[0] + '-sm.jpeg';
  return (
    <BlockWrapper>
      <Link
        to={{ pathname: item.src.split("/")[0], hash: `item-${index}` }}
        params={{ index }}
      >
        {item.locked && <SimpleLocked />}
        <LazyLoad>
          <img
            alt={`${item.title} - Item ${index}`}
            style={{ display: "flex", height: "100%" }}
            src={`${process.env.REACT_APP_DEMO_IMAGE_PREVIEWS_URL}${preview_sm}`}
          />
        </LazyLoad>
      </Link>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.div`
  border-radius: 5px;
  overflow: hidden;
  transition: all 250ms ease-in-out;
  margin-bottom: 30px;
  position: relative;
  box-shadow: 0 0 25px rgba(40, 47, 60, 0.05), 0 4px 10px rgba(40, 47, 60, 0.05),
    0 3px 4px rgba(40, 47, 60, 0.05);

  img {
    width: 100%;
  }
`;

class App extends Component {
  render() {
    return (
      <Layout>
        <div className="container">
          {config.categories.map((c, idx) => {
            return (
              <div key={idx}>
                <div className="row">
                  <div className="col">
                    <h2>{c.titleLong}</h2>
                  </div>
                </div>
                <div className="row">
                  {c.items.map((i, idx) => {
                    const classes = [];

                    if (c.display && c.display.classes) {
                      classes.push(...c.display.classes);
                    } else {
                      classes.push("col-3");
                    }

                    return (
                      <div
                        className={classNames(classes)}
                        style={(c.display && c.display.styles) || null}
                        key={idx}
                      >
                        <Block item={i} index={idx} />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </Layout>
    );
  }
}

export default App;